import React, { Component } from "react";
import { Provider } from "react-redux";
import { Redirect } from "react-router";

import { API } from "../../../../api/api";
import { authStore } from "../../store/store";
import ResetPwdPage from "./ResetPwdPage";

export default class ResetPwd extends Component {
    render() {
        return API.getLoginStatus().loggedIn ? (
            <Redirect to="/" />
        ) : (
            <Provider store={authStore}>
                <ResetPwdPage />
            </Provider>
        );
    }
}
